import PracticesPage from './PracticesPage';

export default function ArchivedPracticesPage() {
  return <PracticesPage />;
}
